module.exports = __webpack_public_path__ + "media/videos/l_affinity_poster-3bbfd8c0580fe55e4ed0edfdc0ffcf5a.jpg";